import { useEffect } from 'react';

type DragCallbackFunction = (e: DragEvent) => void;
type UseDocumentDragDetectParams = {
    onDragEnter?: DragCallbackFunction;
    onDragLeave?: DragCallbackFunction;
    onDrop?: DragCallbackFunction;
};

export default function useDocumentDragDetect({
    onDragEnter,
    onDragLeave,
    onDrop,
}: UseDocumentDragDetectParams) {
    useEffect(() => {
        const handleDragEnter = (e: DragEvent) => {
            e.preventDefault(); // Prevent default to allow drop
            onDragEnter?.(e);
        };

        const handleDragLeave = (e: DragEvent) => {
            e.preventDefault();
            onDragLeave?.(e);
        };

        const handleDrop = (e: DragEvent) => {
            e.preventDefault(); // Prevent the browser's default file open behavior
            onDrop?.(e);
        };

        // It's important to use `dragover` for onDragEnter to continuously allow drop
        document.addEventListener('dragover', handleDragEnter);
        document.addEventListener('dragleave', handleDragLeave);
        document.addEventListener('drop', handleDrop);

        return () => {
            document.removeEventListener('dragover', handleDragEnter);
            document.removeEventListener('dragleave', handleDragLeave);
            document.removeEventListener('drop', handleDrop);
        };
    }, [onDragEnter, onDragLeave, onDrop]); // Dependency array ensures effect is re-run if callbacks change
}
